import { render, staticRenderFns } from "./MakeResveration.vue?vue&type=template&id=13364313"
import script from "./MakeResveration.vue?vue&type=script&lang=js"
export * from "./MakeResveration.vue?vue&type=script&lang=js"
import style0 from "./MakeResveration.vue?vue&type=style&index=0&id=13364313&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports